/** 供应链 路由 **/

import Layout from "@/views/layout/Layout";

const supplyChainRouter = {
  path: "/supplyChainMan",
  component: Layout,
  name: "supplyChainMan",
  meta: {
    title: "供应链",
    icon: "example",
    roles: ["gongyinglian"]
  },
  alwaysShow: true,
  children: [
    // 2 基础档案
    {
      path: "basicArchives",
      component: () => import("@/views/supplyChainMan/basicArchives/index"),
      meta: {
        title: "基础档案",
        roles: ["jichudangan"]
      },
      alwaysShow: true,
      children: [
        // 1 商品管理 - 商品档案分类、资产分类、商品档案
        {
          path: "commodityMan",
          component: () =>
            import("@/views/supplyChainMan/basicArchives/commodityMan/index"),
          name: "商品管理",
          meta: {
            title: "商品管理",
            roles: ["shangpinguanli"]
          }
        },
        // 2 供应商管理 - 供应商分类、供应商档案
        {
          path: "supplierMan",
          component: () =>
            import("@/views/supplyChainMan/basicArchives/supplierMan/index"),
          name: "供应商管理",
          meta: {
            title: "供应商管理",
            roles: ["gongyingshangguanli"]
          }
        },
        // 3 业务控制 - 库房设置、部门业务控制、基层常用商品、商品供应商管理、供应商商品管理
        {
          path: "businessControl",
          component: () =>
            import(
              "@/views/supplyChainMan/basicArchives/businessControl/index"
            ),
          name: "业务控制",
          meta: {
            title: "业务控制",
            roles: ["yewukongzhi"]
          }
        },

        // 4 待维护商品
        {
          path: "unInfoGoods",
          component: () =>
            import("@/views/supplyChainMan/basicArchives/unInfoGoods"),
          name: "待维护商品",
          meta: {
            title: "待维护商品",
            roles: ["daiweihushangpin"]
          }
        }
      ]
    },
    // 3 用料管理
    {
      path: "materialsMan",
      component: () => import("@/views/supplyChainMan/materialsMan/index"),
      meta: {
        title: "用料管理",
        roles: ["yongliaoguanli"]
      },
      alwaysShow: true,
      children: [
        {
          path: "materialTransfer",
          component: () =>
            import("@/views/supplyChainMan/materialsMan/materialTransfer/index"),
          name: "物资转移",
          meta: {
            title: "物资转移",
            roles: ["wuzizhuanyi"]
          }
        },


        // 2 物资需求 - 紧急采购，计划采后，汇总单详细
        {
          path: "materialDemand",
          component: () =>
            import("@/views/supplyChainMan/materialsMan/materialDemand/index"),
          name: "物资需求",
          meta: {
            title: "物资需求",
            roles: ["wuzixuqiu"]
          }
        },
        {
          path: "oldProductMaterial",
          component: () =>
            import(
              "@/views/supplyChainMan/materialsMan/oldProductMaterial/index"
            ),
          name: "旧品提料",
          meta: {
            title: "旧品提料",
            roles: ["jiupintiliao"]
          }
        },
        {
          path: "demandClear",
          component: () =>
            import("@/views/supplyChainMan/materialsMan/demandClear/index"),
          name: "需求清减",
          meta: {
            title: "需求清减",
            roles: ["xuqiuqingjian"]
          }
        },

        // 3 到货验收
        {
          path: "gylAcceptance",
          component: () =>
            import("@/views/supplyChainMan/materialsMan/acceptance"),
          name: "到货验收",
          meta: {
            title: "到货验收",
            roles: ["daohuoyanshou"]
          }
        },

        // 4 我的物资
        {
          path: "myGoods",
          component: () =>
            import("@/views/supplyChainMan/materialsMan/myGoods/index"),
          name: "我的物资",
          meta: {
            title: "我的物资",
            roles: ["wodewuzi"]
          }
        },

        // 4 物资查询
        {
          path: "goodsQuery",
          component: () =>
            import("@/views/supplyChainMan/materialsMan/goodsQuery"),
          name: "物资查询",
          meta: {
            title: "物资查询",
            roles: ["wuzichaxun"],
            keepAlive: true
          }
        },

        // 4 物资收回
        {
          path: "goodsBack",
          component: () =>
            import("@/views/supplyChainMan/materialsMan/goodsBack"),
          name: "物资收回",
          meta: {
            title: "物资收回",
            roles: ["wuzishouhui"]
          }
        },

        // 5 物资返库申请
        {
          path: "materialReturnApplication",
          component: () =>
            import(
              "@/views/supplyChainMan/materialsMan/materialReturnApplication"
            ),
          name: "物资返库申请",
          meta: {
            title: "物资返库申请",
            roles: ["wuzifankushenqing"]
          }
        },

        // 6 资产返库申请
        {
          path: "assetReturnApplication",
          component: () =>
            import(
              "@/views/supplyChainMan/materialsMan/assetReturnApplication"
            ),
          name: "资产返库申请",
          meta: {
            title: "资产返库申请",
            roles: ["zichanfankushenqing"]
          }
        },

        // 7 可盘查物资报废登记
        {
          path: "materialScrappingRegistration",
          component: () =>
            import(
              "@/views/supplyChainMan/materialsMan/materialScrappingRegistration"
            ),
          name: "物资报废登记",
          meta: {
            title: "物资报废登记",
            roles: ["wuzibaofeidengji"]
          }
        },

        // 9 回退待修改
        {
          path: "materialAppoint",
          component: () =>
            import("@/views/supplyChainMan/materialsMan/materialAppoint"),
          name: "回退待修改",
          meta: {
            title: "回退待修改",
            roles: ["huituidaixiugai"]
          }
        },
        // 10 待办列表
        {
          path: "daibanList",
          component: () =>
            import("@/views/supplyChainMan/materialsMan/daibanList"),
          name: "待办列表",
          meta: {
            title: "待办列表",
            roles: ["gyl_daibanliebiao"]
          }
        },
      ]
    },
    // 4 采购管理
    {
      path: "purchasingMan",
      component: () => import("@/views/supplyChainMan/purchasingMan/index"),
      meta: {
        title: "采购管理",
        roles: ["caigouguanli"]
      },
      alwaysShow: true,
      children: [
        // 1 采购计划
        {
          path: "purchasingPlan",
          component: () =>
            import("@/views/supplyChainMan/purchasingMan/purchasingPlan/index"),
          name: "采购计划",
          meta: {
            title: "采购计划",
            roles: ["caigoujihua"]
          }
        },

        // 2 采购询价
        {
          path: "purchasingInquiry",
          component: () =>
            import(
              "@/views/supplyChainMan/purchasingMan/purchasingInquiry/index"
            ),
          name: "采购询价",
          meta: {
            title: "采购询价",
            roles: ["caigouxunjia"]
          }
        },

        // 3 采购单
        {
          path: "purchasingBill",
          component: () =>
            import("@/views/supplyChainMan/purchasingMan/purchasingBill/index"),
          name: "采购单",
          meta: {
            title: "采购单",
            roles: ["caigoudan"]
          }
        },

        // 4 采购到货通知(发送)
        {
          path: "arrivalNotice",
          component: () =>
            import("@/views/supplyChainMan/purchasingMan/arrivalNotice/index"),
          name: "到货通知",
          meta: {
            title: "到货通知",
            roles: ["daohuotongzhi"]
          }
        },

        // 退货处理
        {
          path: "returnGoods",
          component: () =>
            import("@/views/supplyChainMan/purchasingMan/returnGoods"),
          name: "退货处理",
          meta: {
            title: "退货处理",
            roles: ["tuihuochuli"]
          }
        },

        // 取货处理
        {
          path: "getGoods",
          component: () =>
            import("@/views/supplyChainMan/purchasingMan/getGoods"),
          name: "取货处理",
          meta: {
            title: "取货处理",
            roles: ["quhuochuli"]
          }
        },

        // 送货处理
        {
          path: "sendGoods",
          component: () =>
            import("@/views/supplyChainMan/purchasingMan/sendGoods"),
          name: "送货处理",
          meta: {
            title: "送货处理",
            roles: ["songhuochuli"]
          }
        },
        {
          path: "materialStatistics",
          component: () =>
            import("@/views/supplyChainMan/purchasingMan/materialStatistics"),
          name: "物料统计",
          meta: {
            title: "物料统计",
            roles: ["caigouwuliaotongji"]
          }
        }
      ]
    },
    // 5 库房管理
    {
      path: "reservoirMan",
      component: () => import("@/views/supplyChainMan/reservoirMan/index"),
      meta: {
        title: "库房管理",
        roles: ["kufangguanli"]
      },
      alwaysShow: true,
      children: [
        // 1 出库方案
        {
          path: "needOutStock",
          component: () =>
            import("@/views/supplyChainMan/reservoirMan/needOutStock"),
          name: "出库方案",
          meta: {
            title: "出库方案",
            roles: ["chukufangan"]
          }
        },

        // 2 入库验收
        {
          path: "inStockCheck",
          component: () =>
            import("@/views/supplyChainMan/reservoirMan/inStockCheck"),
          name: "入库验收",
          meta: {
            title: "入库验收",
            roles: ["rukuyanshou"]
          }
        },

        // 3 入库管理
        {
          path: "inStockMan",
          component: () =>
            import("@/views/supplyChainMan/reservoirMan/inStockMan"),
          name: "入库管理",
          meta: {
            title: "入库管理",
            roles: ["rukuguanli"]
          }
        },

        // 4 出库单待配货
        {
          path: "outStockMan",
          component: () =>
            import("@/views/supplyChainMan/reservoirMan/outStockMan/index"),
          name: "出库管理",
          meta: {
            title: "出库管理",
            roles: ["chukuguanli"]
          }
        },

        // 5 盘点管理
        {
          path: "inventoryMan",
          component: () =>
            import("@/views/supplyChainMan/reservoirMan/inventoryMan"),
          name: "盘点管理",
          meta: {
            title: "盘点管理",
            roles: ["pandianguanli"]
          }
        },

        // 6 退货申请
        {
          path: "returnRequest",
          component: () =>
            import("@/views/supplyChainMan/reservoirMan/returnRequest"),
          name: "退货申请",
          meta: {
            title: "退货申请",
            roles: ["tuihuoshenqing"]
          }
        },

        {
          path: "replenishApply",
          component: () =>
            import("@/views/supplyChainMan/reservoirMan/replenishApply"),
          name: "补货申请",
          meta: {
            title: "补货申请",
            roles: ["buhuoshenqing"]
          }
        },

        {
          path: "replenishAudit",
          component: () =>
            import("@/views/supplyChainMan/reservoirMan/replenishAudit"),
          name: "补货申请审核",
          meta: {
            title: "补货申请审核",
            roles: ["buhuoshenqingshenhe"]
          }
        },

        // 7 物资返库处理
        {
          path: "materialReturnDeal",
          component: () =>
            import("@/views/supplyChainMan/reservoirMan/materialReturnDeal"),
          name: "物资返库处理",
          meta: {
            title: "物资返库处理",
            roles: ["wuzifankuchuli"]
          }
        }
      ]
    },
    // 8 报表
    {
      path: "reportForm",
      component: () => import("@/views/supplyChainMan/reportForm/index"),
      meta: {
        title: "报表管理",
        roles: ["gylbaobiaoguanli"]
      },
      alwaysShow: true,
      children: [
        {
          path: "purchase",
          component: () =>
            import("@/views/supplyChainMan/reportForm/purchase/index"),
          name: "采购",
          meta: {
            title: "采购",
            roles: ["gylcaigou"]
          },
          alwaysShow: true,
          children: [
            // 0423毕师傅隐藏
            // {
            //   path: "purchaseStatistics",
            //   component: () =>
            //     import(
            //       "@/views/supplyChainMan/reportForm/purchase/purchaseStatistics"
            //     ),
            //   name: "采购工作统计",
            //   meta: {
            //     title: "采购工作统计",
            //     roles: ["gylcaigougongzuotongji"]
            //   },
            //   children: []
            // },
            // purchaseOrderSummary
            {
              path: "purchaseOrderSummary",
              component: () =>
                import(
                  "@/views/supplyChainMan/reportForm/purchase/purchaseOrderSummary"
                ),
              name: "采购单汇总",
              meta: {
                title: "采购单汇总",
                roles: ["gylcaigoudanhuizong"]
              },
              children: []
            }
          ]
        },
        {
          path: "warehouse",
          component: () =>
            import("@/views/supplyChainMan/reportForm/warehouse/index"),
          name: "库房",
          meta: {
            title: "库房",
            roles: ["gylkufang"]
          },
          alwaysShow: true,
          children: [
            {
              path: "sendReceiveSummary",
              component: () =>
                import(
                  "@/views/supplyChainMan/reportForm/warehouse/sendReceiveSummary"
                ),
              name: "收发存汇总表",
              meta: {
                title: "收发存汇总表",
                roles: ["gylshoufacunhuizongbiao"]
              }
            },
            {
              path: "materialSchedule",
              component: () =>
                import(
                  "@/views/supplyChainMan/reportForm/warehouse/materialSchedule"
                ),
              name: "提料执行进度表",
              meta: {
                title: "提料执行进度表",
                roles: ["gyltiliaozhixingjindubiao"]
              }
            },
            {
              path: "inventoryQuery",
              component: () =>
                import(
                  "@/views/supplyChainMan/reportForm/warehouse/inventoryQuery"
                ),
              name: "库存查询表",
              meta: {
                title: "库存查询表",
                roles: ["gylkucunchaxunbiao"]
              }
            },
            {
              path: "outboundQuery",
              component: () =>
                import(
                  "@/views/supplyChainMan/reportForm/warehouse/outboundQuery"
                ),
              name: "库房出库类型查询表",
              meta: {
                title: "库房出库类型查询表",
                roles: ["gylkufachukuleixingchaxunbiao"]
              }
            },
            {
              path: "inventoryStatistical",
              component: () =>
                import(
                  "@/views/supplyChainMan/reportForm/warehouse/inventoryStatistical"
                ),
              name: "盘点统计",
              meta: {
                title: "盘点统计",
                roles: ["gylpandiantongji"]
              }
            },
            {
              path: "inventoryParameter",
              component: () =>
                import(
                  "@/views/supplyChainMan/reportForm/warehouse/inventoryParameter"
                ),
              name: "库存台账",
              meta: {
                title: "库存台账",
                roles: ["gylkucuntaizhang"]
              }
            },
            {
              path: "materialApplyAllocation",
              component: () =>
                import(
                  "@/views/supplyChainMan/reportForm/warehouse/materialApplyAllocation"
                ),
              name: "物资申请分配明细表",
              meta: {
                title: "物资申请分配明细表",
                roles: ["gylwuzishenqingfenpeimingxibiao"]
              }
            }
          ]
        },
        {
          path: "assets",
          component: () =>
            import("@/views/supplyChainMan/reportForm/assets/index"),
          name: "资产",
          meta: {
            title: "资产",
            roles: ["gylzichan"]
          },
          alwaysShow: true,
          children: [
            {
              path: "assetLossScrapDetail",
              component: () =>
                import(
                  "@/views/supplyChainMan/reportForm/assets/assetLossScrapDetail"
                ),
              name: "资产丢失报废明细",
              meta: {
                title: "资产丢失报废明细",
                roles: ["gylzichandiushibaofeimingxi"]
              },
              children: []
            }
          ]
        },
        {
          path: "frontline",
          component: () =>
            import("@/views/supplyChainMan/reportForm/frontline/index"),
          name: "一线",
          meta: {
            title: "一线",
            roles: ["gylyixian"]
          },
          alwaysShow: true,
          children: [
            {
              path: "materialUsed",
              component: () =>
                import(
                  "@/views/supplyChainMan/reportForm/frontline/materialUsed"
                ),
              name: "物料使用统计表",
              meta: {
                title: "物料使用统计表",
                roles: ["gylwuliaoshiyongtongji"]
              },
              children: []
            },
            {
              path: "materialContrast",
              component: () =>
                import(
                  "@/views/supplyChainMan/reportForm/frontline/materialContrast"
                ),
              name: "物料年度对比表",
              meta: {
                title: "物料年度对比表",
                roles: ["gylwuliaonianduduibibiao"]
              },
              children: []
            }
          ]
        },
        {
          path: "finance",
          component: () =>
            import("@/views/supplyChainMan/reportForm/frontline/index"),
          name: "财务",
          meta: {
            title: "财务",
            roles: ["gylcaiwu"]
          },
          alwaysShow: true,
          children: [
            {
              path: "lxExpenseReimbursement",
              component: () =>
                import(
                  "@/views/costMan/reportForm/lxExpenseReimbursement"
                ),
              name: "报销单管理",
              meta: {
                title: "报销单管理",
                roles: ["gylbaoxiaodanguanli"]
              },
              children: []
            }
          ]
        }
      ]
    }
  ]
};

export default supplyChainRouter;
